import { Link } from "react-router-dom";
import { Phone, MapPin, Star, ExternalLink } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/business";

export const Footer = () => (
  <footer className="bg-ink text-white relative grain" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 grid gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2.5 mb-5">
          <span className="grid place-items-center w-10 h-10 rounded-md bg-copper text-ink font-display font-extrabold text-sm" aria-hidden="true">NL</span>
          <span className="font-display font-extrabold tracking-[0.14em] text-lg">NEW&nbsp;LOOKZ</span>
        </div>
        <p className="text-white/60 text-sm leading-relaxed max-w-xs">
          A modern local hair salon in Gandhi Nagar, Hyderabad — haircuts, styling, hair care and grooming.
        </p>
        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-copper/30 px-4 py-2 text-sm text-copper" data-testid="footer-rating">
          <Star size={14} fill="currentColor" aria-hidden="true" />
          {BUSINESS.googleRating} Google Rating · {BUSINESS.googleReviewCount} reviews
        </div>
      </div>

      <nav aria-label="Footer">
        <h3 className="font-display font-bold text-sm tracking-[0.2em] text-copper mb-5">QUICK LINKS</h3>
        <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-white/65 hover:text-copper-hover transition-colors">
                {l.label}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/book" data-testid="footer-book" className="text-white/65 hover:text-copper-hover transition-colors">Book Appointment</Link>
          </li>
        </ul>
      </nav>

      <div>
        <h3 className="font-display font-bold text-sm tracking-[0.2em] text-copper mb-5">CONTACT</h3>
        <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="flex items-center gap-2.5 text-white/85 hover:text-copper-hover transition-colors text-sm mb-4">
          <Phone size={15} aria-hidden="true" /> {BUSINESS.phoneDisplay}
        </a>
        <address className="not-italic text-white/60 text-sm leading-relaxed flex gap-2.5">
          <MapPin size={15} className="mt-1 shrink-0" aria-hidden="true" />
          <span>{BUSINESS.addressLines.map((l) => <span key={l} className="block">{l}</span>)}</span>
        </address>
        <div className="mt-4 text-white/60 text-sm" data-testid="footer-hours">
          {BUSINESS.hours.length
            ? BUSINESS.hours.map((h) => <p key={h.days}>{h.days}: {h.time}</p>)
            : <p>{BUSINESS.hoursNote}</p>}
        </div>
        <div className="mt-5 flex flex-wrap gap-4 text-sm">
          <a href={BUSINESS.mapsEmbedUrl.replace("&output=embed", "")} target="_blank" rel="noopener noreferrer" data-testid="footer-google-maps" className="inline-flex items-center gap-1.5 text-copper hover:text-copper-hover transition-colors">
            Google Maps <ExternalLink size={13} aria-hidden="true" />
          </a>
          <a href={BUSINESS.googleReviewsUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-google-reviews" className="inline-flex items-center gap-1.5 text-copper hover:text-copper-hover transition-colors">
            Google Reviews <ExternalLink size={13} aria-hidden="true" />
          </a>
          {BUSINESS.socials.map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-copper hover:text-copper-hover transition-colors">
              {s.label} <ExternalLink size={13} aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
      © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
    </div>
    <div className="h-[76px] md:hidden" aria-hidden="true" />
  </footer>
);
